// Адреса направлений: витрины и начало заказа.
import type { Direction } from "../api/types";

export const SHOWCASE_PATH: Record<Direction, string> = { miniature: "/mini", gift: "/gift" };
export const NEW_ORDER_PATH: Record<Direction, string> = {
  miniature: "/new/miniature",
  gift: "/new/gift",
};

export function directionClass(direction: Direction): string {
  return direction === "gift" ? "gift" : "mini";
}
